export const SAVE_ALL_AUTHORIZED_SERVICES = 'SAVE_ALL_AUTHORIZED_SERVICES'
export const SAVE_AUTHORIZED_SERVICE = 'SAVE_AUTHORIZED_SERVICE'
